import React from 'react'

type Props = {}

const BetdailyAppStepOneIcon = (props: Props) => {
  return (
    <svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_b_702_21)">
      <circle cx={24} cy={24} r={24} fill="url(#paint0_linear_702_21)" />
      <circle cx={24} cy={24} r={24} fill="url(#paint1_linear_702_21)" />
    </g>
    <g clipPath="url(#clip0_702_21)">
      <path
        d="M26.2737 32.7353C26.2737 33.986 25.2557 35 24 35C22.7444 35 21.7264 33.986 21.7264 32.7353C21.7264 31.4846 22.7444 30.4706 24 30.4706C25.2557 30.4706 26.2737 31.4846 26.2737 32.7353ZM30.3922 29.0141C30.8828 28.5254 30.8828 27.7331 30.3922 27.2444C29.5624 26.4179 28.5958 25.7688 27.5192 25.3152C26.4038 24.8453 25.2199 24.6071 24 24.6071C22.7802 24.6071 21.5962 24.8453 20.4809 25.3152C19.4042 25.7688 18.4376 26.4179 17.6079 27.2444C17.1173 27.7331 17.1173 28.5254 17.6079 29.0141C18.0984 29.5027 18.8939 29.5027 19.3845 29.0141C20.6173 27.7861 22.2564 27.1099 23.9999 27.1099C25.7434 27.1099 27.3825 27.7861 28.6153 29.0141C28.8606 29.2585 29.1821 29.3806 29.5036 29.3806C29.8251 29.3806 30.1466 29.2585 30.3919 29.0141H30.3922ZM15.2647 24.9103C17.5981 22.5862 20.7004 21.3063 24.0002 21.3063C27.2999 21.3063 30.4022 22.5863 32.7356 24.9103C33.2262 25.3989 34.0216 25.3989 34.5122 24.9103C35.0028 24.4216 35.0028 23.6293 34.5122 23.1406C33.8399 22.4709 33.0999 21.8628 32.3129 21.3332C31.5181 20.7984 30.6683 20.339 29.7872 19.9677C27.9536 19.1953 26.0065 18.8036 24.0002 18.8036C21.9938 18.8036 20.0467 19.1953 18.2131 19.9677C17.332 20.339 16.4822 20.7984 15.6874 21.3332C14.9004 21.8628 14.1605 22.4708 13.4881 23.1406C12.9975 23.6293 12.9975 24.4216 13.4881 24.9103C13.7334 25.1547 14.0549 25.2768 14.3764 25.2768C14.6979 25.2768 15.0194 25.1547 15.2647 24.9103ZM38.6322 20.8065C39.1228 20.3179 39.1228 19.5255 38.6322 19.0369C37.6962 18.1045 36.6661 17.2579 35.5707 16.5208C34.4644 15.7764 33.2816 15.1369 32.0552 14.6202C30.8058 14.0939 29.4983 13.6896 28.1692 13.4187C26.806 13.1409 25.4033 13 24.0002 13C22.597 13 21.1943 13.1409 19.8311 13.4187C18.502 13.6896 17.1945 14.0939 15.9452 14.6202C14.7188 15.1369 13.536 15.7764 12.4297 16.5208C11.3342 17.2579 10.3041 18.1045 9.36806 19.0369C8.87748 19.5255 8.87748 20.3179 9.36806 20.8065C9.85864 21.2952 10.6541 21.2952 11.1447 20.8065C14.5786 17.3863 19.1439 15.5027 24.0002 15.5027C28.8564 15.5027 33.4218 17.3863 36.8556 20.8065C37.1009 21.0509 37.4224 21.173 37.7439 21.173C38.0654 21.173 38.3869 21.0509 38.6322 20.8065Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_702_21"
        x={-4150}
        y={-4150}
        width={8348}
        height={8348}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={2075} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_702_21"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_702_21"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_702_21"
        x1={0}
        y1={0}
        x2={47.0669}
        y2={2.39871}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6F6DE6" />
        <stop offset={0.489583} stopColor="#5451D4" />
        <stop offset={1} stopColor="#312DB9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_702_21"
        x1={24}
        y1={0}
        x2={24}
        y2={48}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B21318" />
        <stop offset={1} stopColor="#7D0204" />
      </linearGradient>
      <clipPath id="clip0_702_21">
        <rect width={30} height={22} fill="white" transform="translate(9 13)" />
      </clipPath>
    </defs>
  </svg>
  )
}

export default BetdailyAppStepOneIcon